import React, { useMemo } from 'react';
// @ts-ignore
import { PayPalButton } from 'react-paypal-button-v2';

import { config } from '../../../config';

import { PayBlock } from './card';

import { PaymentMethodProps } from './payment-method.types';
import { PayPrice, PayPriceCommission } from './styled';

import { currencyToSign } from '../../../helpers/currency';
import { getPayPalCommission } from '../../../helpers/commission';
import { simpleSum } from '../../../helpers/numbers';

import { useTranslation } from '../../../i18n';

const styles = {
  label: 'checkout',
  shape: 'rect',
  color: 'gold',
  layout: 'horizontal',
  tagline: true,
};

export const PayWithPayPal: React.FC<PaymentMethodProps> = ({ price, currency, onPay, onError }) => {
  const [t] = useTranslation('rates');

  const sign = currencyToSign(currency);
  const commission = getPayPalCommission(Number(price));

  const fullPrice = useMemo(() => simpleSum([price, commission]), [commission, price]);

  return (
    <PayBlock className="is-hover-shadow">
      <PayPrice>
        {price} {sign}
      </PayPrice>
      <PayPriceCommission>
        (+{t('rates.payments.commission')} {commission} {sign})
      </PayPriceCommission>
      <PayPalButton
        amount={fullPrice}
        options={{
          clientId: config.payPal.clientID,
          currency,
          locale: 'en_US',
        }}
        style={styles}
        onSuccess={onPay}
        onError={onError}
      />
    </PayBlock>
  );
};
